import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EditCourseLevelSidebar } from "./EditCourseLevelSidebar";
import CoreDetails from "./CoreDetails";
import LevelSections from "./LevelSections";
import { PageTitle, PageHeader } from "../../../../components/StyledElements";
import { getCourseLevelInfo } from "../../../../services/courses"
import { AppContext } from "../../../../contexts/AppContext";
import swal from "sweetalert2";

import { useCourseContext } from "../../../../contexts/CoursesContext";

export const EditCourseLevel = () => {
  console.log("!!! RENDERING EditCourseLevel COMPONENT");
  const { selectedClient } = useContext(AppContext);
  const navigate = useNavigate();
  const { course_level_id } = useParams();
  const [courseLevel, setCourseLevel] = useState();
  const [showSidebar, setShowSidebar] = useState(true);
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");
  const { selectedCourse, updatedCourse } = useCourseContext();
  const [courseId, setCourseId] = useState();
  const [courseTitle, setCourseTitle] = useState();

  useEffect(() => {
    if (course_level_id) {
      if (updatedCourse) {
        const level = updatedCourse?.levels?.find((l) => l.public_id === course_level_id);
        setCourseLevel(level);
        setCourseId(updatedCourse.public_id);
        setCourseTitle(updatedCourse.title);
      } else {
        const fetchCourseLevel = async () => {
          const results = await getCourseLevelInfo(course_level_id, selectedClient);
          console.log("!!! course level RESULTS: ", results);
          if (results.success) {
            const level = results.course_level;
            setCourseLevel(level);
            setCourseId(level.course_id);
            setCourseTitle(level.course_title);
          } else {
            swal.fire({
              title: "Error",
              text: results.message || "Failed to fetch course level details.",
              icon: "error",
            }).then(() => {
              navigate(`/courses/${selectedCourse?.public_id}/levels`);
            });
          }
        };
        fetchCourseLevel();

      }
    }
    // eslint-disable-next-line
  }, [course_level_id, updatedCourse]);


  console.log("!!! course level ID: ", course_level_id);

  if (!courseLevel) {
    return;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)", height: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>

        <EditCourseLevelSidebar
          show={showSidebar}
          courseLevel={courseLevel}
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            setSelectedTab(navItem);
          }}
          onToggle={() => {
            setShowSidebar(!showSidebar);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - ${showSidebar ? "250px" : "0px"})`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <PageTitle title={`${courseId ? "Edit" : "New"} Course Level`} style={{ marginBottom: "10px" }} />
            {courseTitle ?
              <PageTitle onClick={() => { navigate(`/course/${courseId}`); }} title={<><i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />{`Course: ${courseTitle}`}</>} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px", cursor: "pointer" }} />
              : null}
            <PageTitle onClick={() => { navigate(`/courselevel/${courseLevel.public_id}`); }} title={<><i className="fa fa-arrow-left" style={{ marginRight: "10px" }} />{`Level: ${courseLevel.title}`}</>} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px", cursor: "pointer" }} />
          </div>
          {/*selectedTab !== "chat-sessions" ? (
            <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
              <CancelButton onClick={() => {
                setUpdatedCourse(selectedCourse);
              }}>Cancel</CancelButton>
              <Button disabled={!canSaveCourse() || savingCourse} onClick={() => { }} style={{ marginLeft: "auto" }}>{savingCourse ? "Saving Changes" : "Save Changes"}</Button>
            </div>
          ) : (
            null
          )*/}
        </PageHeader>
        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px", height: "calc(100% - 80px)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <CoreDetails
                courseLevel={courseLevel}
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <LevelSections
                courseLevel={courseLevel}
                style={{ display: selectedTab === "levels" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditCourseLevel;

